import { FEATURE_FLAG } from '~/constants/featureFlags';

import { type RouteExportParams } from '~/types/router.type';

export const routeParams: RouteExportParams = {
  featureFlag: FEATURE_FLAG.CREATE_DEMO_DLNS,
  vestigasSupportAccess: false, // Override parent route's vestigasSupportAccess to allow non-Vestigas users with the feature flag
};
